module.exports = {"610114001":"凤凰路街道","610114002":"新华路街道","610114003":"振兴街道","610114004":"新兴街道","610114005":"北屯街道","610114006":"武屯街道","610114007":"关山街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610114.json
// module id = 2918
// module chunks = 0